import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
const usePaymentMethods = () => {
  const companyId = useCompanyIdFromUrl();

  return useQuery({
    enabled: !!companyId,
    queryKey: ["paymentMethods", companyId],
    queryFn: () => {
      return apiClient.get(`subscriptions/payment-methods`, {
        params: { companyId },
      });
    },
  });
};

export { usePaymentMethods };
